import { createApolloClient } from 'hubspot-apollo-client';
const client = createApolloClient();
export const fetch = operation => {
  return client.query(operation);
};